




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import appStore from '@/core/app/app.store';
import Api from '@/project/http/Api.service';
import { SearchBlockViewModel } from '@/types/contentServerContract';
import { SearchRequest, SearchViewModel } from '@/types/apiServerContract';
import urlHelperService from '@/core/urlHelper.service';
import { router } from '@/router';
import { Route } from 'vue-router';
import { UrlQueryKey } from '@/core/urlQueryKey';
import translateFilter from '@/core/translation/translate.filter';
import dictionaryService, { NamedLabelArgument } from '@/core/translation/dictionary.service';
import domService from '@/core/dom/dom.service';
const SearchProductControl = () => import('@/project/search/SearchProductControl.vue');
const CategoryFacets = () => import('@/project/search/facets/CategoryFacets.vue');

export const SearchOverlayScrollPositionChanged = 'SearchOverlayScrollPositionChanged';

@Component({
    components: { SearchProductControl, CategoryFacets }
})
export default class SearchPage extends Vue {
    zeroResultContent: SearchBlockViewModel | null = null;
    searchResult: SearchViewModel | null = null;
    hasNoTerm = false;

    @Prop({ type: Boolean, default: false })
    show!: boolean;

    @Prop({ type: Boolean, default: false })
    typing!: boolean;

    @Prop({ type: HTMLElement })
    anchorElement!: HTMLElement;

    @Watch('$route')
    onRouteChange(newRoute: Route, oldRoute: Route) {
        if (newRoute.query[UrlQueryKey.termKey]) {
            this.hasNoTerm = false;
        } else {
            setTimeout(() => {
                this.hasNoTerm = (!(document.activeElement?.tagName === 'INPUT') && !this.$route.query[UrlQueryKey.termKey]);
            }, 1000);
        }
    }

    searchResultCallback(searchResult: SearchViewModel, request?: SearchRequest) {
        this.searchResult = searchResult || null;
        if (searchResult.totalHits === 0 && request?.term) {
            this.handleZeroSearchResults(request.term);
        } else {
            this.zeroResultContent = null;
        }
        this.updatePageTitleAndDescription(request?.term);
    }

    async handleZeroSearchResults(searchTerm: string) {
        Api.search.zeroSearchResultContent(searchTerm).then((result) => {
            if (result) {
                this.zeroResultContent = result;
            }
        });
    }

    get searchTitle(): null | string {
        if (this.searchResult?.searchFallbackExplanation) {
            const values = this.searchResult.searchFallbackExplanation.interpolationValues || [];
            return translateFilter(this.searchResult.searchFallbackExplanation.label, ...values);
        }
        return this.zeroResultContent?.heading || null;
    }

    updatePageTitleAndDescription(searchTerm?: string) {
        const titleKey = 'Search.SEO.Title';
        const descriptionKey = 'Search.SEO.Description';

        const totalHits = dictionaryService.seofyNumbers(this.searchResult?.totalHits);
        const totalResults = totalHits !== undefined ? totalHits.toString(10) : undefined;
        const labelValues: NamedLabelArgument = {
            totalResults: totalResults,
            results: totalResults,
            term: searchTerm
        };

        const title = dictionaryService.getWithNamedValues(titleKey, labelValues, false);
        domService.setTitle(title || '');

        const description = dictionaryService.getWithNamedValues(descriptionKey, labelValues, false);
        domService.setDescription(description || '');
    }

    created() {
        if (!urlHelperService.getTerm()) {
            setTimeout(() => {
                if (!urlHelperService.getTerm()) {
                    router.replace('/');
                }
            }, 2000);
        }
        this.restrictViewport();
    }

    destroyed() {
        this.resetViewport();
    }

    restrictViewport() {
        appStore.setHideBreadcrumb(true);
    }

    resetViewport() {
        appStore.setHideBreadcrumb(false);
    }
}
